import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import titleMixin from "./app/title_mixin"

const app = createApp(App).mixin(titleMixin).use(store).use(router)

app.mount("#app")
